import { useState } from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import TTUBanner from '@cont/TalkToUnacademy/Banner';
import { useRouter } from 'next/router';
import useTTUStore from '@stores/ttu';
import { noOp } from '@constants/empty';
import { getTTUShow, getShowTTUCurtain } from '@stores/selectors/ttuSelectors';
import Dynamic from '@base/Dynamic/Dynamic';
import { showTTUOption } from '@api/fetchers/ttu';
import { TTU_CITY_CENTRE_PAGES_SRC } from '@cont/TalkToUnacademy/constants';
import useTopology from '@api/hooks/topology/useTopology';
import GridContainer from './CommonComponents';

const TTURenderer = Dynamic(() => import('@layout/TTURenderer'));

const TTUWrapper = styled.div`
  grid-column: span 24;
  display: flex;
`;

const StyTTUBanner = styled(TTUBanner)`
  margin-top: ${Spacings.SPACING_20B} !important;
  margin-bottom: ${Spacings.SPACING_20B} !important;
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_0B} !important;
    margin-bottom: ${Spacings.SPACING_0B} !important;
    padding: ${Spacings.SPACING_0B} !important;
  }
`;

const TTUBlock = ({ data }) => {
  const { query } = useRouter();
  const { goalUID } = query;
  const { topology: goalInfo } = useTopology(goalUID);
  const ttuShow = useTTUStore(getTTUShow);
  const showTTUCurtain = useTTUStore(getShowTTUCurtain);

  const [backButton, setBackButton] = useState({
    value: false,
    fn: noOp
  });

  const handleBackPress = () => backButton.fn();
  const ttuOptions = {};

  const onCloseTTU = () => {
    setBackButton({ value: false, fn: noOp });
    showTTUCurtain(false);
    showTTUOption(goalUID);
  };
  return (
    <>
      <GridContainer>
        <TTUWrapper>
          <StyTTUBanner
            goalDetails={goalInfo}
            ttuConfig={{
              ttuEventsProps: {
                batch_group_type: 'Offline'
              },
              title: data?.header,
              subTitle: data?.description,
              phone: data?.callNumber,
              buttonCTA: data?.cta
            }}
          />
        </TTUWrapper>
      </GridContainer>
      <TTURenderer
        // @ts-ignore
        onCloseTTU={onCloseTTU}
        showTTU={ttuShow}
        backButton={backButton}
        setBackButton={setBackButton}
        handleBackPress={handleBackPress}
        ttuTriggerSource={TTU_CITY_CENTRE_PAGES_SRC}
        ttuOptions={ttuOptions}
      />
    </>
  );
};

export default TTUBlock;
